<template>
  <v-container fill-height class="ma-0 pa-0" fluid align="center" justify="center">
    <!-- <t-background style="min-height: 1900px; "></t-background> -->
    <t-background noautoheight style="position: absolute; min-height: 5500px; top: -3600px; width: 1920px"></t-background>
    <v-row align="center" justify="center" class="my-0 py-0 px-2">
      <v-col cols="12" sm="8" md="6" lg="5" xl="5" class="my-0 py-0" align="center">
        <!-- <v-img contain width="auto" :max-width="500" height="auto" style="cursor: pointer" class="ma-0 pa-0" @click="openTremolSite()" :src="require('../../assets/img/tremollogo.png')"></v-img> -->

        <v-row aling="start" justify="space-around">
          <v-col cols="12" sm="12" md="7" lg="7" xl="7" align="center" style="z-index: 10; cursor: pointer">
            <span class="lndtitlelarge" style="z-index: 10; cursor: pointer" @click="$router.push({ path: '/landing' })">
              <span class="lndlogo">TREMOL</span>
              <span style="vertical-align: top; line-height: 50px" class="lndsubtitle">®</span>
              <span class="lndlogoassistant">Assistant</span>
            </span>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5" xl="5" align="center">
            <v-row align="center" justify="center" class="ma-0">
              <div @click="setLanguage('bg')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="bg" size="big" />
              </div>
              <div @click="setLanguage('ro')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="ro" size="big" />
              </div>
              <div @click="setLanguage('md')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="md" size="big" />
              </div>
            </v-row>
          </v-col>
        </v-row>
        <v-card class="elevation-24 mt-4" shaped v-if="isVisible">
          <v-card-text>
            <v-form ref="loginForm" v-model="valid" lazy-validation>
              <v-row align="center" justify="center" class="ma-2 mb-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field ref="refUser" v-model="username" name="username" placeholder=" " autocomplete="username" :label="s_User" prepend-icon="mdi-account" @keyup.enter="login()" />
                </v-col>
                <v-col v-if="!forgotenPasswordMode" cols="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="password"
                    id="password"
                    placeholder=" "
                    prepend-icon="mdi-lock"
                    name="password"
                    autocomplete="current-password"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="s_Password"
                    :rules="global_rules.password"
                    @click:append="show1 = !show1"
                    @keydown="isCapsOn"
                    @keyup.enter="login()"
                  >
                    <CapsTooltip v-if="capsOn" slot="append-outer" />
                  </v-text-field>
                </v-col>
                <!-- <v-col v-if="forgotenPasswordMode" cols="12" class="ma-0 pa-0">
                  <v-text-field ref="refUser" v-model="forgotten_password_code" name="password_code" placeholder=" " autocomplete="username" label="Код за верификация" prepend-icon="mdi-account" />
                </v-col>-->
                <v-col v-if="forgotenPasswordMode" cols="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="forgotten_password"
                    id="forgotten_password"
                    placeholder=" "
                    prepend-icon="mdi-lock"
                    name="password"
                    autocomplete="new-password"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="s_NewPassword"
                    :rules="global_rules.password"
                    @click:append="show1 = !show1"
                    @keydown="isCapsOn"
                  >
                    <CapsTooltip v-if="capsOn" slot="append-outer" />
                  </v-text-field>
                </v-col>
                <v-col v-if="forgotenPasswordMode" cols="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="forgotten_password_confirm"
                    id="forgotten_password_confirm"
                    placeholder=" "
                    prepend-icon="mdi-lock"
                    name="password"
                    autocomplete="new-password"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="s_ConfirmPassword"
                    :rules="global_rules.password"
                    @click:append="show1 = !show1"
                    @keydown="isCapsOn"
                  >
                    <CapsTooltip v-if="capsOn" slot="append-outer" />
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions transition="scale-transition" class="my-0 py-0 pb-2">
            <v-container class="fill-height pt-0 my-0 py-0" fluid v-if="forgotenPasswordMode">
              <v-row class="ma-1 pa-0">
                <v-col cols="12" class="my-0 py-0">
                  <v-btn ref="refBtnLogin" :color="Colors.IconColor" class="white--text" block :disabled="!valid || wait_change_pass_timeout" @click="changePass()" autofocus>{{ s_ChangePassword }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else class="fill-height pt-0 my-0 py-0" fluid>
              <v-row class="ma-1 pa-0" justify="space-between">
                <v-col cols="12" class="my-0 py-0">
                  <v-btn ref="refBtnLogin" :color="Colors.IconColor" class="white--text" block :disabled="!valid || wait_login_timeout" @click="login()" autofocus>{{ s_Login }}</v-btn>
                </v-col>
                <v-col cols="12" lg="4" md="4" class="ma-0 pa-0">
                  <v-btn text small class="font-weight-black" :color="Colors.IconColor" @click="showForgottenPassDialog = true">{{ s_ForgottenPassword }}</v-btn>
                </v-col>
                <v-col cols="12" lg="4" md="4" class="ma-0 pa-0" v-if="TR.Locale == 'bg'">
                  <router-link to="/SignUp">
                    <v-btn text small class="font-weight-black" :color="Colors.IconColor">{{ s_Registration }}</v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" lg="4" md="4" class="ma-0 pa-0">
                  <v-btn text small class="font-weight-black" :color="Colors.IconColor" @click="logWithDemo()">{{ s_Demo }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
        <span class="mа-0 pa-2" style="position: relative; right: 10px; bottom: -7px; font-size: 10px">{{ "v. " + getAppVer() }}</span>
      </v-col>
    </v-row>
    <v-dialog v-model="showForgottenPassDialog" width="500">
      <v-card>
        <v-card-title>
          <v-row align="center" justify="center">
            <span class="subtitle-1">{{ s_ForgottenPassword }}</span>
          </v-row>
        </v-card-title>
        <v-card-actions class>
          <v-container class="fill-height pt-0 my-0 py-0" fluid>
            <v-row class="ma-0 pa-2">
              <v-text-field ref="refUser" v-model="username" name="username" placeholder=" " autocomplete="username" :label="s_User" prepend-icon="mdi-account" @keyup.enter="showForgottenPasswordDialog()" />
            </v-row>
            <v-row class="ma-0 pa-2">
              <v-btn ref="refBtnLogin" :color="Colors.IconColor" class="white--text" block :disabled="wait_login_timeout" @click="showForgottenPasswordDialog()" autofocus>{{ s_SendEmail }}</v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
// import HTTPSender from "../js/HTTPSender";
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { g_Dialog, TR } from "../../main";
import CapsTooltip from "../Controls/CapsTooltip";
import HTTPSender from "../../js/HTTPSender";
import { version } from "../../../package.json";
import { SHOW_DEBUG_MESSAGES } from "../../../my_globals";
import CountryFlag from "vue-country-flag";

export default {
  props: {
    propusername: String,
    proppassword: String,
    source: String,
  },
  components: {
    CapsTooltip,
    CountryFlag,
  },
  data() {
    return {
      TR: TR,
      isVisible: true,
      forgotten_password: "",
      forgotten_password_confirm: "",
      forgotten_password_code: "",
      forgotenPasswordMode: false,
      showForgottenPassDialog: false,
      capsOn: false,
      switch1: false,
      show1: false,
      valid: true,
      wait_login_timeout: false,
      wait_change_pass_timeout: false,
      username: this.propusername,
      password: this.proppassword,
      // emailRules: [
      //   v => !!v || "E-mail is required",
      //   v => /.+@.+/.test(v) || "E-mail must be valid"
      // ],
    };
  },
  computed: {
    s_SendEmail() {
      return TR.SendEmail;
    },
    s_Demo() {
      return TR.Demo;
    },
    s_Registration() {
      return TR.Registration;
    },
    s_ForgottenPassword() {
      return TR.ForgottenPassword;
    },
    s_Login() {
      return TR.Login;
    },
    s_ChangePassword() {
      return TR.ChangePassword;
    },
    s_ConfirmPassword() {
      return TR.ConfirmPassword;
    },
    s_User() {
      return TR.User;
    },
    s_Password() {
      return TR.Password;
    },
    s_NewPassword() {
      return TR.NewPassword;
    },
  },
  methods: {
    getAppVer() {
      return version;
    },
    async setLanguage(lang) {
      if (TR.Locale != lang) {
        // this.isVisible = false;
        this.setLang(lang);
        // this.$nextTick(() => {
        await this.$router.push({ path: this.$router.currentRoute.path, query: { lang: lang } });

        this.$router.go(0);

        // });
        // setTimeout(() => {
        //   this.isVisible = true;
        // }, 1234);
        // this.$nextTick(() => {
        //   this.$router.push({ path: "/login", query: { lang: lang } }).then(() => {
        //     this.$router.go(0);
        //   });
        // });

        // this.$router.push({ path: "/login", query: { lang: lang } }).then(() => {
        //   this.$router.go(0);
        // });
        //
      }
    },
    isCapsOn(e) {
      this.capsOn = this.isCapsLockOn(e);
    },
    logWithDemo() {
      this.username = "Демо";
      this.password = "      ";
      this.$nextTick(() => {
        this.login();
      });
    },
    changePass() {
      if (this.$refs.loginForm && this.$refs.loginForm.validate() && !this.wait_change_pass_timeout) {
        this.wait_change_pass_timeout = true;
        DataManager.changeUserPasswordWithResetCode(
          {
            userName: this.username,
            pswResetCode: this.forgotten_password_code,
            newPassword: this.forgotten_password,
            newConfirmPassword: this.forgotten_password_confirm,
          },
          (err) => {
            if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
              this.dialogLoader.showInfo(TR.PasswordChangedSuccessfully, { timeout: 3000, location: "center" });
              this.forgotenPasswordMode = false;
            } else {
              this.dialogLoader.hide();
              this.dialogLoader.showError(TR.Error + "! " + err.Message, { timeout: 5000, location: "center" });
            }
            setTimeout(() => {
              this.wait_change_pass_timeout = false;
            }, 3000);
          }
        );
      }
    },
    showForgottenPasswordDialog() {
      if (!this.username) {
        this.dialogLoader.showError(TR.PleaseEnterUsername, { timeout: 5000, location: "center" });
      } else {
        this.wait_login_timeout = true;
        DataManager.sendForgottenPasswordEmail({ userName: this.username }, (err) => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.showForgottenPassDialog = false;
            this.dialogLoader.showInfo(TR.EmailWithCodeSent + "\n" + TR.PleaseCheckEmail, { timeout: 5000, location: "center" });
          } else {
            this.dialogLoader.hide();
            this.dialogLoader.showError(TR.Error + "! " + err.Message, { timeout: 5000, location: "center" });
          }
          setTimeout(() => {
            this.wait_login_timeout = false;
          }, 3000);
        });
      }
    },
    async login() {
      if (this.$refs.loginForm && this.$refs.loginForm.validate() && !this.wait_login_timeout) {
        this.wait_login_timeout = true;
        await this.dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.Logging }).then(() => {
          setTimeout(
            () => {
              DataManager.login(this.username, this.password, (err) => {
                if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                  var user = DataManager.getData(DataManager.DataType.user, true);
                  if (user.settings1) {
                    var ifc = user.settings1.interface;
                    if (ifc) {
                      Object.keys(ifc).forEach((o) => {
                        this.userSettings[o] = ifc[o];
                      });
                    }
                    var cols = user.settings1.columns;
                    if (cols) {
                      Object.keys(cols).forEach((col) => {
                        var dt = DataManager.DataType[col];
                        if (dt) {
                          var colKeys = Object.keys(cols[col]);
                          DataManager.headers[dt.id].forEach((h) => {
                            var k = colKeys.find((prop) => prop == h.value);
                            h.hidden = !!cols[col][k];
                          });
                        }
                      });
                    }
                  }
                  this.$vuetify.theme.dark = this.userSettings.darkMode;
                  this.dialog.close();
                  this.dialogLoader.hide();
                  this.$router
                    .push({ path: "/MainContent" })
                    .catch(() => {})
                    .then(async () => {
                      var path = "/" + TR.Locale + "/settings";

                      if (user.settings1) {
                        var loggedRecently = user.settings1.loginLastDate && user.settings1.loginLastDate.addMinutes(30) > new Date();
                        if (loggedRecently && !SHOW_DEBUG_MESSAGES) {
                          user.settings1.loginCountToday++;
                        } else {
                          user.settings1.loginCountToday = 1;
                        }
                        user.settings1.loginLastDate = new Date();
                        user.settings1.loginLastBrowser = navigator.sayswho;

                        if (user.settings1.notFirstLogin || DataManager.___demoMode) {
                          // if (!user.observerCuser && !user.isDistributor) {

                          if (this.userSettings.startPage) {
                            if (this.userSettings.startPage.startsWith("/" + TR.Locale + "/")) {
                              path = this.userSettings.startPage;
                            } else {
                              path = "/" + TR.Locale + "/" + this.userSettings.startPage;
                            }
                          } else {
                            path = "/" + TR.Locale + "/dashboard";
                          }
                          // }
                        } else {
                          user.settings1.notFirstLogin = true;
                        }

                        // if (TR.Locale == Translation.bg.Locale) {
                        DataManager.updateUserSettings(user.settings1);
                        // }
                      }
                      var mustSub = user.approved && !user.observerCuser && !user.isDistributor && DataManager.getData(DataManager.DataType.devices, true).every((d) => !d.duprofile || !d.duprofile.csubscriptionPlan || d.duprofile.csubscriptionPlan.id == -1);
                      if (mustSub) {
                        path = "/" + TR.Locale + "/subscription";
                      }

                      if (loggedRecently && !SHOW_DEBUG_MESSAGES) {
                        var coef = 4 + Math.round(user.settings1.loginCountToday / 10);
                        if (coef > 8) coef = 8;
                        await g_Dialog.show(
                          g_Dialog.dialog_types.captcha,
                          null,
                          {
                            // text: "Системата е отчела прекалено много опити за влизане!\nДанните в приложението се опресняват автоматично, не е необходимо да излизате и влизате повторно.\n\nМоля въведете кода от изображението, за да продължите нататък!",
                            text: TR.PleaseInputCaptcha,
                            captchaLength: coef,
                          },
                          (result) => {
                            if (result) {
                              try {
                                this.pickTechnician(user, path, mustSub);
                              } catch {
                                /** ignored */
                              }
                            } else {
                              this.username = "";
                              this.password = "";
                              this.wait_login_timeout = true;
                              setTimeout(() => {
                                this.wait_login_timeout = false;
                              }, 3000);
                              this.logout(true);
                            }
                          }
                        );
                      } else {
                        this.pickTechnician(user, path, mustSub);
                      }
                    });
                } else {
                  this.dialogLoader.hide();
                  this.dialog.close();
                  this.dialogLoader.showError(TR.Error + "! " + err.Message, { timeout: 5000, location: "center" });
                  this.username = "";
                  this.password = "";
                }
                setTimeout(() => {
                  this.wait_login_timeout = false;
                }, 3000);
              });
            },
            SHOW_DEBUG_MESSAGES ? 1 : 5555
          );
        });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  updated() {
    this.dialogLoader.hide();
  },
  created() {
    if (this.$route.query.lang) {
      this.setLang(this.$route.query.lang);
    }
    bus.$on("logWithDemo", () => {
      this.logWithDemo();
    });
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.$nextTick(() => {
          this.booleans.isLoading = false;
        });
        var ver = localStorage.getItem("PACKAGE_VERSION");
        if (version != ver) {
          localStorage.setItem("PACKAGE_VERSION", version);
          try {
            window.location.reload(true);
          } catch {
            var asd = window.location.href;
            window.location.href = asd;
          }
        }
      }
    };
    DataManager.__clean();
    // this.$nextTick(() => {
    //   this.$refs.refPass.$el.focus();
    //   this.$nextTick(() => {
    //     this.$refs.refUser.$el.focus();
    //   });
    // });
    if (this.$route.query.r) {
      HTTPSender.SetBearer(this.$route.query.r);
      DataManager.loadData(DataManager.DataType.user, (err) => {
        DataManager.getData(DataManager.DataType.user, true).isDistributor = true;
        DataManager.userType = DataManager.UserTypes.Distributor;
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          DataManager.loadData(DataManager.DataType.subscription_plans, () => {
            DataManager.loadData(DataManager.DataType.discounts, () => {
              DataManager.loadData(DataManager.DataType.messages, () => {
                this.$router.push({ path: "/" + TR.Locale + "/help" }).catch(() => {});
              });
            });
          });
        } else {
          this.dialogLoader.hide();
          this.dialogLoader.showError("Грешка! " + err.Message, { timeout: 5000, location: "center" });
        }
      });
    } else if (this.$route.query.psw_reset) {
      this.forgotenPasswordMode = true;
      this.forgotten_password_code = this.$route.query.psw_reset;
    } else if (this.$route.query.demo) {
      this.$nextTick(() => {
        this.logWithDemo();
      });
    }
  },
};
</script>
